import { useMutation } from "./urqlHooks";

const AI_GATEWAY_CHAT = `
  mutation AI_GATEWAY_CHAT($input: AiGatewayChatInput!) {
    aiGatewayChat(input: $input) {
      reply
      details
      ui
      contextForNextTurn
      trace {
        trace_id
        status
        template_id
        intent
        module
        entity
      }
    }
  }
`;

const REPORT_AI_GATEWAY_CONVERSATION = `
  mutation REPORT_AI_GATEWAY_CONVERSATION($input: AiGatewayConversationReportInput!) {
    reportAiGatewayConversation(input: $input) {
      success
      message
      reportId
    }
  }
`;

export const useAiGatewayChat = () => {
  const [result, executeMutation] = useMutation(AI_GATEWAY_CHAT);
  return {
    fetching: result.fetching,
    error: result.error,
    executeMutation: async (input) => {
      const r = await executeMutation({ input });
      if (r.error) return { data: null, error: r.error };
      return { data: r.data, error: null };
    },
  };
};

export const useReportAiGatewayConversation = () => {
  const [result, executeMutation] = useMutation(REPORT_AI_GATEWAY_CONVERSATION);
  return {
    fetching: result.fetching,
    error: result.error,
    executeMutation: async (input) => {
      const r = await executeMutation({ input });
      if (r.error) return { data: null, error: r.error };
      return { data: r.data, error: null };
    },
  };
};

